import { render } from "./JitsiIframe.vue?vue&type=template&id=34ef9fb2"
import script from "./JitsiIframe.vue?vue&type=script&lang=js"
export * from "./JitsiIframe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__